<template>
  <div>
    <!-- 卡片列表 -->
    <div v-loading="loading"
         class="card-item-list">
      <div style="width:33%;"
           v-for="(o, index) in itemList"
           :key="index">
        <!-- 模块 -->
        <div class="card-item-style">
          <!-- 图片 -->
          <img class="card-item-image"
               @click="clickCard(o)"
               :src="o.image" />

          <!-- 文字 -->
          <div class="content-item-text"
               @click="clickCard(o)">
            <h3 class="card-text-title">
              {{ o.title }}
            </h3>
          </div>
        </div>
        <!-- 文字结束 -->
      </div>

    </div>

  </div>
</template>

<script>
export default {
  name: 'card-check-list',
  data() {
    return {
      loading: false,
      itemList: this.cardList,
      isChecked: -1,
      // 已选列表
      checked_list: [],
    }
  },
  watch: {
    cardList(val) {
      this.itemList = val
    },
  },
  props: {
    cardList: {
      type: Array,
      default: () => {
        return [{}, {}, {}, {}]
      },
    },
  },
  methods: {
    clickCard(val) {
      this.$emit('checkCard', val)
    },
    checkedItem(value) {
      // console.log(this.checked_list)
      let arrItemIndex = this.checked_list.indexOf(value.id)
      if (arrItemIndex > -1) {
        this.checked_list.splice(arrItemIndex, 1)
      } else {
        this.checked_list.push(value.id)
      }
      this.$emit('checkedItem', this.checked_list)
    },
  },
}
</script>

<style scoped>
/* 卡片 */
.card-item-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: flex-start;
}
.card-item-list:after {
  /* 占位 */
  width: 30%;
  content: '';
}
.card-item-style {
  margin: 20px 5px 10px 10px;
}
.card-item-image {
  cursor: pointer;
  border: 1px solid #ffffff;
  border-radius: 10px;
  height: 100px;
  width: 100%;
  object-fit: cover;
}
.content-item-text {
  background-color: #ff5421;
  color: #fff;
  height: 30px;
  /* border-bottom: 0.1rem solid; */
  border-radius: 10px;
}

.card-text-title {
  text-align: center;
  font-size: 18px;
  word-break: keep-all;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ------------------------------------ */
</style>